import Environment from "../models/Environment";

export class DatImageUtility {
    public static getJpgImageUrl = (labId?: number, imageName?: string): string => {
        return `${Environment.testImageUrl}/${labId || 0}/dat/${imageName || 'unknown'}.jpg`;
    };
    public static getImageUrl = (labId?: number, imageName?: string): string => {
        return `${Environment.testImageUrl}/${labId || 0}/dat/${imageName}`;
    };
}